// Shared singletons for the UI layer.
import { db } from '../db/schema.js';
import { Repositories } from '../db/repositories.js';

export const repos = new Repositories(db);
